import React from "react"
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";
export default function Footer() {
    const { t } = useTranslation();
    return (
        <footer>
            <div className="pb-[30px]">
                <img className="w-full h-auto" src={require("../../assets/icons/footer-border.svg").default} alt="" />
            </div>
            <div className="f-col container flex gap-[40px]">
                <div className="w-100 w-[48%] flex flex-col gap-[15px]">
                    <div>
                        <img className="w-[120px] h-[120px]" src={require("../../assets/logo/logo.svg").default} alt="" />
                    </div>
                    <p>
                        {t("footer text")}
                    </p>
                    <div className="flex items-center gap-[5px]">
                        <Link to={"https://www.facebook.com/share/1AC7Ns69DC/"}>
                            <img className="w-[34px] h-[34px]" src={require("../../assets/icons/facebook-footer.svg").default} alt="" />
                        </Link>
                        <Link to={"https://www.instagram.com/alnujoud_drugstore?igsh=MXJiMXk3Y3doeGo5bA=="}>
                            <img className="w-[34px] h-[34px]" src={require("../../assets/icons/insta-footer.svg").default} alt="" />
                        </Link>
                        <Link to={"https://wa.link/suy089"}>
                            <img className="w-[34px] h-[34px]" src={require("../../assets/icons/whatsapp-footer.svg").default} alt="" />
                        </Link>
                    </div>
                </div>
                <div className="w-100 f-col w-[48%] flex gap-[50px] justify-end">
                    <div className="flex flex-col gap-[15px]">
                        <div className="w-fit">
                            <div className="text-[25px] text-[#017E89] capitalize font-bold">{t("quick links")}</div>
                            <img className="w-full h-[16px]" src={require("../../assets/icons/footer-line.svg").default} alt="" />
                        </div>
                        <ul className="flex flex-col gap-[7px]">
                            <li className="flex items-center gap-[5px]">
                                <img className="w-[12px] h-[12px]" src={require("../../assets/icons/arrow-footer.svg").default} alt="" />
                                <Link to={"/"}>{t("Home")}</Link>
                            </li>
                            <li className="flex items-center gap-[5px]">
                                <img className="w-[12px] h-[12px]" src={require("../../assets/icons/arrow-footer.svg").default} alt="" />
                                <Link to={"/about"}>{t("About us")}</Link>
                            </li>
                            <li className="flex items-center gap-[5px]">
                                <img className="w-[12px] h-[12px]" src={require("../../assets/icons/arrow-footer.svg").default} alt="" />
                                <Link to={"/product"}>{t("Products")}</Link>
                            </li>
                            <li className="flex items-center gap-[5px]">
                                <img className="w-[12px] h-[12px]" src={require("../../assets/icons/arrow-footer.svg").default} alt="" />
                                <Link to={"/ceo"}>{t("CEO Message")}</Link>
                            </li>
                            <li className="flex items-center gap-[5px]">
                                <img className="w-[12px] h-[12px]" src={require("../../assets/icons/arrow-footer.svg").default} alt="" />
                                <Link to={"/news"}>{t("News & Events")}</Link>
                            </li>
                            <li className="flex items-center gap-[5px]">
                                <img className="w-[12px] h-[12px]" src={require("../../assets/icons/arrow-footer.svg").default} alt="" />
                                <Link to={"/team"}>{t("Our Team")}</Link>
                            </li>
                            <li className="flex items-center gap-[5px]">
                                <img className="w-[12px] h-[12px]" src={require("../../assets/icons/arrow-footer.svg").default} alt="" />
                                <Link to={"/suppliers"}>{t("Our Suppliers")}</Link>
                            </li>
                            <li className="flex items-center gap-[5px]">
                                <img className="w-[12px] h-[12px]" src={require("../../assets/icons/arrow-footer.svg").default} alt="" />
                                <Link to={"/contact"}>{t("Contact Us")}</Link>
                            </li>
                        </ul>
                    </div>
                    <div className="flex flex-col gap-[15px]">
                        <div className="w-fit">
                            <div className="text-[25px] text-[#017E89] capitalize font-bold">{t("Contact us")}</div>
                            <img className="w-full h-[16px]" src={require("../../assets/icons/footer-line.svg").default} alt="" />
                        </div>
                        <ul className="flex flex-col gap-[7px]">
                            <li className="flex items-center gap-[5px]">
                                <img className="w-[25px] h-[25px]" src={require("../../assets/icons/phone-footer.svg").default} alt="" />
                                <Link to={"tel:+962 7 9201 0100"}>+962 7 9201 0100</Link>
                            </li>
                            <li className="flex items-center gap-[5px]">
                                <img className="w-[25px] h-[25px]" src={require("../../assets/icons/email-footer.svg").default} alt="" />
                                <Link to={"mailto:info@alnujoud-jo.com"}>info@alnujoud-jo.com</Link>
                            </li>
                            <li className="flex items-center gap-[5px]">
                                <img className="w-[25px] h-[25px]" src={require("../../assets/icons/location-footer.svg").default} alt="" />
                                <Link to={"https://www.google.com/maps/dir/?api=1&destination=31.9038%2C35.8467"}>Marj al hamam, Amman, Jordan</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="font-13-center bg-[#64AAB2] flex items-center justify-center py-3.5 text-white font-bold mt-[30px]">
                {t("Copyright ©️ 2025  Al Nujoud Drug Store . All Rights Reserved.")}
            </div>
        </footer>
    )
}